// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3vo5I","buttons":"PendingPaymentAlert_buttons__3OsJ1"};